import Vue from 'vue'
import Router from 'vue-router'

import Full from '@/containers/Full'

import Dashboard from '@/views/Dashboard'
import Login from '@/views/pages/Login'
import Page404 from '@/views/pages/Page404'

import MemberList from '@/views/pages/MemberList'
import Performance from '@/views/pages/Performance'
import Realtime from '@/views/pages/Realtime'
import Advertisement from '@/views/pages/Advertisement'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: Full,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'member-list',
          name: 'Member List',
          component: MemberList
        },
        {
          path: 'realtime',
          name: 'Realtime',
          component: Realtime
        },
        {
          path: 'performance',
          name: 'Performance',
          component: Performance
        },
        {
          path: 'advertisement',
          name: 'Advertisement',
          component: Advertisement
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '*',
      name: 'Page404',
      component: Page404
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js